import { FC, MouseEvent } from 'react'
import styled from 'styled-components'
import { colors } from '../components'
import { ReactComponent as Plus } from '../images/icons_2023/add.svg'
import { ReactComponent as InfoIcon } from '../images/icons_2023/artist-details.svg'
import { ReactComponent as Minus } from '../images/icons_2023/minus.svg'
import { ReactComponent as ProfileIcon } from '../images/2026/icons/profile.svg'

type FavoriteProps = {
  $isFavorite?: boolean
  $isWhite?: boolean
  $isSmall?: boolean
  $toggleColor?: boolean
}

type PlusButtonProps = FavoriteProps & {
  onClick?: (event: MouseEvent<HTMLDivElement>) => void
  variant?: 'plus' | 'minus'
}

type InfoButtonProps = PlusButtonProps & {
  icon?: 'info' | 'profile'
}

const SPlusButton = styled.div<FavoriteProps>`
  font-size: 1.5rem;
  display: flex;
  align-items: center;
  justify-content: center;

  cursor: pointer;
  user-select: none;
  box-sizing: border-box;

  svg {
    width: 32px;
    height: 32px;
  }

  & .bg {
    fill: ${(props) => {
      if (props.$toggleColor && props.$isFavorite) {
        return colors.Entry.favorite.bg
      }
      return props.$isFavorite ? colors.plusButtonFavorite : colors.plusButton
    }};
  }

  & .content {
    fill: ${(props) =>
      props.$isFavorite
        ? colors.plusButtonIconFavorite
        : colors.plusButtonIcon};
  }
`

export const SPlusIcon = styled.div<FavoriteProps>`
  transform: ${(props) =>
    props.$isFavorite ? 'rotate(45deg)' : 'rotate(0deg)'};
  transition: transform 0.2s ease-out;
  width: 32px;
  height: 32px;
`

export const PlusButton: FC<PlusButtonProps> = ({
  $isFavorite,
  onClick,
  variant = 'plus',
  $toggleColor,
}) => {
  return (
    <SPlusButton
      $isFavorite={$isFavorite}
      onClick={(event) => {
        onClick && onClick(event)
        event.preventDefault()
        event.stopPropagation()
      }}
    >
      <SPlusIcon $isFavorite={$isFavorite} $toggleColor={$toggleColor}>
        {variant === 'plus' ? <Plus /> : <Minus />}
      </SPlusIcon>
    </SPlusButton>
  )
}

export const SInfoButton = styled(SPlusButton)<{ $icon?: 'info' | 'profile' }>`
  background: none;

  & svg {
    width: ${(props) => (props.$isSmall ? '24px' : '32px')};
    height: ${(props) => (props.$isSmall ? '24px' : '32px')};
  }

  ${(props) => {
    if (props.$icon === 'profile') {
      return `
    color: ${colors.Entry.profileIcon};

    & .content {
      fill: currentColor;
    }
  `
    }

    let bgFill = colors.primary
    if (props.$isWhite) {
      bgFill = props.$isFavorite ? colors.text : colors.textInverted
    } else if (props.$isFavorite) {
      bgFill = colors.white
    }

    return `
    & .bg {
      fill: ${bgFill};
    }
  `
  }}
`

export const InfoButton: FC<InfoButtonProps> = ({
  onClick,
  $isFavorite,
  $isWhite,
  $isSmall,
  icon = 'info',
}) => {
  return (
    <SInfoButton
      onClick={onClick}
      $isFavorite={$isFavorite}
      $isWhite={$isWhite}
      $isSmall={$isSmall}
      $icon={icon}
    >
      {icon === 'profile' ? <ProfileIcon /> : <InfoIcon />}
    </SInfoButton>
  )
}
